export default function SuccessTxBadge() {
  return (
    <svg width="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M27 47.25V47.25C15.8152 47.25 6.75 38.1848 6.75 27V27C6.75 15.8152 15.8152 6.75 27 6.75V6.75C38.1848 6.75 47.25 15.8152 47.25 27V27C47.25 38.1848 38.1848 47.25 27 47.25Z" stroke="#22C55E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M36 22.5L24.75 33.75L18 27" stroke="#22C55E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
